<div class="ostso-dialog">
  <div class="header">
  <h1>{{ isNew ? "Создание показателя" : "Редактирование показателя" }}</h1>
    <button mat-icon-button class="close-button" (click)="onNoClick()">
      <mat-icon>close</mat-icon>
    </button>

  </div>
  <div mat-dialog-content>
    <form class="form" [formGroup]="form">
      <input class="remarktype-textarea" matInput [formControlName]="'name'" placeholder="Показатель">
      <input class="remarktype-textarea" matInput [formControlName]="'shortName'"
             placeholder="Условное обозначение">

      <pas-choise title="Тип оценки" [items]="periods" [formControlName]="'period'">
        <ng-template #name let-item>
          {{ item.name }}
        </ng-template>
      </pas-choise>

      <mat-expansion-panel [expanded]="true" class="mat-elevation-z0"
                           [style]="{'background-color': '#F3F4F6'}">
        <mat-expansion-panel-header>Вес показателя</mat-expansion-panel-header>
        <mat-form-field>
          <input matInput [formControlName]="'weight'" type="number" step="0.01">
        </mat-form-field>
      </mat-expansion-panel>

      <pas-multi-select3 [formControlName]="'indexes'"
                         title="Индекс"
                         [customDataService]="indexService"
                         [options]="{pageSize: 1e6}"
                         customDialogMethod="apiIndexGet"
                         filteredObjectName="indicators"
      >
        <ng-template #listItem let-item>
            {{ item.name }} ({{ item.shortName }}), (ID: {{ item.id }})
        </ng-template>
        <ng-template #dialogList let-item>
            {{ item.name }} ({{ item.shortName }}), (ID: {{ item.id }})
        </ng-template>
      </pas-multi-select3>

      <mat-expansion-panel [expanded]="true" class="mat-elevation-z0"
                           [style]="{'background-color': '#F3F4F6'}">
        <mat-expansion-panel-header>ЦБ</mat-expansion-panel-header>
        <div class="controls" [style]="{'justify-content': 'flex-start'}" formArrayName="cb">
          @for (item of cbs.controls; track item.value; let i = $index) {
            <div class="control" [class.active]="hasCbType(i)">
              <input type="checkbox" [formControlName]="i" name="cb"/>
              <span>{{ cbTypes[i].name }}</span>
            </div>
          }
        </div>
      </mat-expansion-panel>

      <pas-choise title="Исполнитель" [items]="implementerType" [formControlName]="'implementerType'">
        <ng-template #name let-item>
          {{ item.label }}
        </ng-template>
      </pas-choise>

      <h3 class="label">Конструктор формулы</h3>
      <div class="formula-constructor__constructor">
        @for (i of indexesControl; track i.name) {
          <button class="formula-constructor__button" [attr.data-label]="i.name" (click)="saveToClipboard(i.shortName)">
            {{ i.shortName }}
          </button>
        }
<!--        <pre>{{indexItems | json}}</pre>-->
        @for (i of indexItems; track i.name) {
          <button class="formula-constructor__button red" [attr.data-label]="i.name" (click)="saveToClipboard(i.shortName)">
            {{ i.shortName }}
          </button>
        }
      </div>
      <pas-formula-constructor [formControlName]="'formula'" label="Методика значения показателя"/>
      <pas-formula-constructor [formControlName]="'pointFormula'" label="Методика бального значения показателя"/>
    </form>
  </div>
  <div mat-dialog-actions>
    <button class="btn btn-blue" mat-button (click)="onApply()" [disabled]="!form.valid || everyItemsIsFalse">Применить</button>
    <button class="btn btn-secondary" mat-button (click)="onNoClick()">Сбросить</button>
  </div>
</div>

